import { render } from "./introduceList.vue?vue&type=template&id=415b2a4f"
import script from "./introduceList.vue?vue&type=script&lang=js"
export * from "./introduceList.vue?vue&type=script&lang=js"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__